<template>
  <section
    class="invoice-preview-wrapper"
    style="position: relative"
  >
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="estimate === undefined"
    >
      <h4 class="alert-heading">
        Error fetching invoice data
      </h4>
      <div class="alert-body">
        No invoice found with this invoice id. Check <b-link
          class="alert-link"
          :to="{ name: 'estimate-list' }"
        >
          invoice List
        </b-link> for other invoice.
      </div>
    </b-alert>
    <b-row
      v-if="estimate"
      class="invoice-preview"
    >
      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <b-row style="border: 1px solid black; border-radius: 18px; padding: 10px">
            <!-- Header: Left Content -->
            <b-col
              cols="12"
              md="12"
              style="color: black; font-size: 18px; text-align: center"
            >
              <div
                style="color: black; font-size: 40px"
                class="mt-1 font-weight-bolder"
              > Vente machine clé et accessoires <br>
                <b-card-text
                  style="font-size: 20px"
                  class="font-weight-bold mt-1"
                >
                  <div
                    style="color: black; font-size: 28px"
                    class="font-weight-bolder"
                  >
                    Kacem Mohamed
                  </div>
                  <div class="mt-1">
                    Rue ds parfumes Nabeul
                  </div>
                  <div class="mt-1 mb-1">
                    97 607 740
                  </div>
                </b-card-text>
              </div>
            </b-col>
          </b-row>
          <div class="mt-1">
            <b-row style="color: black">
              <b-col
                cols="8"
                md="8"
                sm="12"
              >
                <h3
                  class="font-weight-bolder"
                  style="
                    color: black;
                    font-size: 28px;
                    border: 1px solid black;
                    padding: 10px;
                    text-align: center;
                  "
                > DEVIS </h3>
                <div class="mt-1 d-flex">
                  <table style="border: 1px solid black">
                    <tr
                      style="
                        color: black;
                        font-size: 20px;
                        border: 1px solid black;
                      "
                    >
                      <th
                        style="text-align: center"
                        class="font-weight-bolder"
                      >
                        N° du pièce
                      </th>
                    </tr>
                    <tr
                      style="
                        color: black;
                        font-size: 20px;
                        border: 1px solid black;
                      "
                    >
                      <td
                        v-if="estimate"
                        style="text-align: center"
                        class="font-weight-bolder"
                      >
                        {{ estimate.number }}
                      </td>
                    </tr>
                  </table>
                  <table style="border: 1px solid black; margin-left: 10px">
                    <tr
                      style="
                        color: black;
                        font-size: 20px;
                        border: 1px solid black;
                      "
                    >
                      <th
                        style="text-align: center"
                        class="font-weight-bolder"
                      >
                        Date
                      </th>
                    </tr>
                    <tr
                      style="
                        color: black;
                        font-size: 20px;
                        border: 1px solid black;
                      "
                    >
                      <td
                        v-if="estimate"
                        style="text-align: center"
                        class="font-weight-bolder"
                      >
                        {{ format(estimate.date) }}
                      </td>
                    </tr>
                  </table>
                </div>
              </b-col>
              <b-col
                v-if="estimate.customer"
                cols="4"
                md="4"
                sm="12"
                style="
                  border: 1px solid black;
                  border-radius: 18px;
                  font-size: 18px;
                  padding: 10px;
                  background-color: #eeede9;
                "
              >
                <!-- Header: Left Content -->
                <div style="color: black; font-size: 20px">
                  <h4
                    style="color: black; font-size: 20px"
                    class="mb-1 font-weight-bolder"
                  >
                    {{ estimate.customer.company_name }}
                  </h4>
                  <span class="mb-0 mt-1 font-weight-bold">
                    {{ estimate.customer.address }}
                  </span>
                  <b-card-text
                    v-if="estimate.customer.tax_identification_number"
                    class="mb-0 mt-1 font-weight-bold"
                  > MF : {{ estimate.customer.tax_identification_number }}
                  </b-card-text>
                  <b-card-text
                    v-else
                    class="mb-0 mt-1 font-weight-bold"
                  > CIN : {{ estimate.customer.cin }}
                  </b-card-text>
                </div>
                <!-- Header: Right Content -->
                <!-- Header: Right Content -->
              </b-col>
            </b-row>
          </div>
          <!-- Invoice Description: Table -->
          <table class="container-products mt-2">
            <b-table-lite
              :small="true"
              responsive
              :items="p"
              :fields="[
                'N°',
                'Réf',
                'Désignation',
                'Qté',
                'Prix U.H.T',
                'Total H.T',
                'Taux TVA',
                'Prix U.TTC',
                'Total TTC',
              ]"
              class="ta font-weight-bold mt-1"
            />
          </table>
          <!-- Invoice Description: Total -->
          <div class="pagebreak">
            <b-row class="card-body">
              <b-col
                cols="6"
                md="6"
                xl="6"
                sm="12"
                style="
                  border: 1px solid black;
                  padding: 10px;
                  border-radius: 18px;
                "
              >
                <span
                  class="font-weight-bolder mt-1"
                  style="
                    color: black;
                    border-bottom: 1px solid black;
                    font-size: 20px;
                  "
                > Arrêté le présent devis a la somme de : </span>
                <br>
                <br>
                <span
                  class="font-weight-bold mt-1"
                  style="color: black; font-size: 20px"
                >
                  {{ lettre }}
                </span>
                <!-- <div v-html="order.note" /> -->
              </b-col>
              <b-col cols="1" />
              <b-col
                cols="5"
                md="5"
                xl="5"
                sm="12"
                class="p-0"
                style="
                  border: 1px solid black;
                  padding: 10px;
                  border-radius: 18px;
                "
              >
                <table class="border-pricing m-1">
                  <tbody>
                    <tr class="trborder">
                      <th
                        scope="row"
                        style="color: black; font-size: 20px"
                        class="border-pricing"
                      >
                        Total H.Tva :
                      </th>
                      <td
                        style="color: black; font-size: 20px"
                        class="font-weight-bold border-pricing"
                      >
                        {{ estimate.price_ht }}
                      </td>
                    </tr>
                    <tr
                      class="trborder"
                      style="color: black; font-size: 20px"
                    >
                      <th
                        scope="row"
                        class="border-pricing"
                      >
                        Total Tva :
                      </th>
                      <td class="font-weight-bold border-pricing">
                        {{ estimate.tax }}
                      </td>
                    </tr>
                     <tr style="color: black; font-size: 20px">
                      <th
                        scope="row"
                        class="border-pricing"
                      >
                        Timbre :
                      </th>
                      <td class="font-weight-bold border-pricing">
                        1
                      </td>
                    </tr>
                    <tr style="color: black; font-size: 20px">
                      <th
                        scope="row"
                        class="border-pricing"
                      >
                        Total TTC :
                      </th>
                      <td class="font-weight-bold border-pricing">
                        {{ estimate.price_ttc }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row class="card-body text-center">
              <b-col
                cols="6"
                md="6"
                xl="6"
                sm="12"
              >
                <h5 style="color: black; font-size: 16px">
                  Signature
                </h5>
              </b-col>
              <b-col
                cols="6"
                md="6"
                xl="6"
                sm="12"
              >
                <h5 style="color: black; font-size: 16px">
                  La durée de validité accordée à ce devis est de 2 mois à partir du date de création
                </h5>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>
          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Print
          </b-button>
          <!-- Button: Edit -->
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import axiosIns from '@/libs/axios'

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import { NumberToLetter } from 'convertir-nombre-lettre'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
  },
  data() {
    return {
      p: [],
      estimate: [],
      lettre: '',
    }
  },

  created() {
    this.id = this.$route.params.id
    this.getEstimate()
    this.getProducts()
  },
  methods: {
    format(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    async getEstimate() {
      const { data } = await axiosIns.get(`/estimates/details/${this.id}/`)
      this.estimate = data
      const sommeString = this.estimate.price_ttc.toString()
      if (sommeString.includes('.000') === true) {
        this.lettre = `${NumberToLetter(this.estimate.price_ttc)} Dinars `
      } else {
        const [dinar, milim] = this.estimate.price_ttc.split('.')
        this.lettre = `${NumberToLetter(dinar)} Dinars , ${NumberToLetter(
          milim,
        )} `
      }
    },

    async getProducts() {
      const { data } = await axiosIns.post('/estimates-products/details/', {
        estimate: this.id,
      })
      for (let i = 0; i < data.length; i += 1) {
        this.addnewitem(
          i + 1,
          data[i].reference,
          data[i].label,
          data[i].quantity,
          data[i].price_ht,
          data[i].total_ht,
          data[i].vat,
          data[i].price_ttc,
          data[i].total_ttc,
        )
      }
    },

    // eslint-disable-next-line camelcase
    addnewitem(
      nb,
      reference,
      label,
      quantity,
      price_ht,
      total_ht,
      tax,
      price_ttc,
      total_ttc,
    ) {
      this.p.push({
        Réf: reference,
        Désignation: label,
        Qté: quantity,
        'Prix U.H.T': price_ht,
        'Total H.T': total_ht,
        'Taux TVA': tax,
        'Prix U.TTC': price_ttc,
        'Total TTC': total_ttc,
        'N°': nb,
      })
    },
  },
  setup() {
    const printInvoice = () => {
      window.print()
    }

    return {
      printInvoice,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-invoice.scss";
.trborder {
  border-bottom: 0px solid black;
}
footer {
  bottom: 0;
  height: auto; /* Footer height */
}
.container-products{
  min-height: 600px;
  border: 1px solid black;
}
table {
  width: 100%;
  border-collapse: collapse;
}
.mycolor {
  background-color: #208a9d;
}
.contact {
  background-color: #208a9d;
  padding: 10px;
  border-radius: 20px;
}
@media print {
  @page {
    size: A4;
  }
  html, body {
    height: 99%;
  }
  .pagebreak {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
  }

  .ta {
    overflow-x: visible;
    font-size: 18px;
    color: black;
  }

  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: auto; /* Footer height */
  }

  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  .mycolor {
    background-color: #208a9d;
    -webkit-print-color-adjust: exact;
  }
  .contact {
    background-color: #208a9d;
    padding: 20px;
    border-radius: 25px;
    -webkit-print-color-adjust: exact;
  }
  footer footer-light footer-static {
    display: inline-block;
  }
  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
  table {
    width: 100%;
  }
  * {
    color: black !important;
  }

  .border-pricing {
    text-align: left;
    border: 0px solid black;
  }
}
</style>
